import { Injectable } from '@angular/core';
import {
    ISieveFilterObject,
    SieveOperator,
    SieveSortOrder
} from '../helpers/sieve/sieveString.class';
import { UtilsDateService } from '../helpers/utils-date.service';
import { SieveSort } from '../helpers/sieve/sieve-filters-and-sorts';

@Injectable()
export class GlobalsService {
    readonly PRICELIST_TO_DATE_INTERVAL = { N_DAYS_AGO: 60, YEARS_FROM_NOW: 100 };
    readonly pricelistToDateSortDesc = {
        key: SieveSort.Catalog.ValidoFino,
        order: SieveSortOrder.Desc
    };
    constructor(private dateService: UtilsDateService) {}

    //PRICELISTS
    pricelistToDateIntervalFilters(minIsToday: boolean = false): ISieveFilterObject[] {
        const _filters = [];
        const lowerDate = new Date();
        if (!minIsToday) {
            lowerDate.setDate(lowerDate.getDate() - this.PRICELIST_TO_DATE_INTERVAL.N_DAYS_AGO);
        }
        const lowerFilter = {
            key: SieveSort.Catalog.ValidoFino,
            operator: SieveOperator.GoE,
            value: this.dateService.inputDateGetter(lowerDate)
        };
        _filters.push(lowerFilter);
        //greater
        const greaterDate = new Date();
        greaterDate.setFullYear(
            greaterDate.getFullYear() + this.PRICELIST_TO_DATE_INTERVAL.YEARS_FROM_NOW
        );
        const greaterFilter = {
            key: SieveSort.Catalog.ValidoFino,
            operator: SieveOperator.LoE,
            value: this.dateService.inputDateGetter(greaterDate)
        };
        _filters.push(greaterFilter);
        return _filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/globals.service.ts